import { PeriodSelect } from '@/components/TaxReport/PeriodSelect';
import { ActionMenu } from '@/components/TaxReport/ActionMenu';
import { MonthRangePickerMobile } from '@/kit/DatePickers/MonthRangePickerMobile';
import s from './index.module.scss';

export const FilterViewMobile = ({ params, onDateChange }) => {
  return (
    <div className={s.wrapper}>
      <div className={s.list}>
        <div className={s.scroll}>
          <PeriodSelect mobile range={params.range} onChange={onDateChange} />
          <MonthRangePickerMobile
            range={params.range}
            setRange={onDateChange}
            maxDate={new Date()}
          />
        </div>
        <div className={s.fade_right} />
      </div>
      <ActionMenu />
    </div>
  );
};
